'use strict';

const Reflux = require('@muzzylane/reflux');

const WebSocketActions = require('../actions/WebSocketActions');
const SignInStore = require('./SignInStore');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const ActivityActions = require('../actions/ActivityActions');

const MAX_RECONNECTS = GlobalConfig.WebSocketOptions.reconnectionAttempts;
const RECONNECT_DELAY = GlobalConfig.WebSocketOptions.reconnectionDelay;
// const MAX_RECONNECTS = 0; //testing failed
const REFRESH_LOCK_TIME = parseInt(GlobalConfig.WebSocketOptions.activityLockDuration, 10) / 2;

let initialized = false;
let storeState = "";
let message = "";
let signedIn = false;
let action = {};
let error = null;

let connection_lost = false;
let connection_perm_lost = false;
let refreshLockInterval = -1;
let flagToDisconnect = false;
let force_unlock_data = null;

let actWebSocket = null;
let reconnectAttempt = 0;

var WebSocketStore = Reflux.createStore({
    listenables: [WebSocketActions, ActivityActions],
    init: function() {
        signedIn = SignInStore.getState().initializedLocal;
        this.listenTo(SignInStore, this.onSignInChange);
    },

    onSignInChange: function(signInStoreState){
        signedIn = signInStoreState.initializedLocal;
    },

    getState: function() {
        return {
            initialized: initialized,
            actWebSocket: actWebSocket,
            error: error,
            action: action,
            connection_lost: connection_lost,
            connection_perm_lost: connection_perm_lost,
            force_unlock_data: force_unlock_data, // indicates when we get a force unlock 'request'
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        error = null;
    },

    _resetStoredWebsocket() {
        initialized = false;
        reconnectAttempt = 0;
        connection_lost = false;
        connection_perm_lost = false;
        actWebSocket = null;
    },

    onGetActivityLockCompleted: function(actionID, actWS) {
        //console.log("in onGetActivityLockCompleted");
        action = { id: actionID };
        actWebSocket = actWS;
        initialized = true;
        connection_lost = false;
        connection_perm_lost = false;

        this._setupConnectionListeners();
        this.emitStatus();
    },

    onGetActivityLockFailed: function(actionID, actWS, activityId, err) {
        console.warn("onGetActivityLockFailed: ", actionID, activityId, err);
        action = { id: actionID };

        if(err && err.step) {
            switch(err.step) {
                case "ws_url":
                    //todo
                    break;
                case "ws_connect":
                    //todo
                    break;
                case "ws_authenticate":
                    //todo
                    break;
                case "test_activity_lock":
                    //todo
                    break;
                case "request_activity_lock":
                    //todo
                    break;
                case "reestblish_activity_lock":
                    //todo
                    break;
                default:
                    break;
            }
        }
        else {
            console.warn("onGetActivityLockFailed no error, non-standard error returned!");
        }

        // if(err.status){
        //     switch(err.status){
        //         default:
        //             action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
        //     }
        // }
        // else {
        //     action.error = err;
        // }

        actWebSocket = actWS;
        initialized = true;
        error = err;

        this.emitStatus();
    },

    onReestablishActivityLockCompleted: function(actionID, actWS) {
        // console.log("in onReestablishActivityLockCompleted!");
        action = { id: actionID };
        actWebSocket = actWS;
        initialized = true;
        connection_lost = false;
        connection_perm_lost = false;
        reconnectAttempt = 0;
        this._setupConnectionListeners();
        this.emitStatus();

        // testing disconnect
        // window.setTimeout(function() {
            // actWebSocket.sock.disconnect();
        // }, 10000);
    },

    onReestablishActivityLockFailed: function(actionID, activityId, err) {
        console.warn("onReestablishActivityLockFailed: ", actionID, activityId, err);
        this._attemptReconnect();
    },

    onReleaseActivityLockCompleted: function(actionID, activityId) {
        // console.log("in onReleaseActivityLockCompleted!");
        this._removeRefreshLockInterval();
        action = { id: actionID };
        this._resetStoredWebsocket();
        this.emitStatus();
    },

    onReleaseActivityLockFailed: function(actionID, err) {
        console.error("in onReleaseActivityLockFailed!", err);
        this._removeRefreshLockInterval();
        action = { id: actionID };
        this._resetStoredWebsocket();
        //todo: error handling
        this.emitStatus();
    },
    
    onClearForceUnlockStateCompleted: function(actionId) {
        action = { id: actionId };
        force_unlock_data = null;
        this.emitStatus();
    },
    onClearForceUnlockStateFailed: function(actionId) {
        action = { id: actionId };
        this.emitStatus();
    },

    _attemptReconnect: function() {
        const self = this;
        if (reconnectAttempt < MAX_RECONNECTS) {
            window.setTimeout(function() {
                console.log(`reconnect attempt ${(reconnectAttempt + 1)}/${MAX_RECONNECTS}`);
                reconnectAttempt++;
                WebSocketActions.reestablishActivityLock('store-reest-lock', {
                    actWebSocket: actWebSocket
                });
            }, reconnectAttempt > 0 ? RECONNECT_DELAY : 0);
        }
        else {
            connection_perm_lost = true;
            actWebSocket.disconnect()
                .then(function() {
                    self.emitStatus();
                });
        }
    },

    _setupConnectionListeners: function() {
        const self = this;
        //console.log('_setupConnectionListeners flagToDisconnect:', flagToDisconnect);
        if (flagToDisconnect) {
            //TODO: calling action from store breaks flux pattern. not sure how else to trigger this action
            //console.log('calling WebSocketActions.releaseActivityLock due to flagToDisconnect');
            WebSocketActions.releaseActivityLock('flag-release', { actWebSocket: actWebSocket });
            flagToDisconnect = false;
        }
        
        function messageHandler(msg) {
            if (msg.type === 'force_activity_unlock') {
                force_unlock_data = {
                    start_time: new Date(),
                    timeout_ms: GlobalConfig.WebSocketOptions.forceUnlockTime,
                    id: msg.id, // forge activity id
                    activityID: msg.activityID, // nova_act_id,
                    kickerName: msg.kickerName,
                    clientResponseToken: msg.clientResponseToken,
                };
                self.emitStatus();
            }
        }

        function disconnectCallback() {
            connection_lost = true;
            actWebSocket.sock.removeListener("msg", messageHandler);
            actWebSocket.sock.removeListener("disconnect", disconnectCallback);
            self._removeRefreshLockInterval();
            self._attemptReconnect();
            self.emitStatus();
        }

        actWebSocket.sock.on("disconnect", disconnectCallback);
        actWebSocket.sock.on("msg", messageHandler);
        this._addRefreshLockInterval();
    },

    _addRefreshLockInterval: function() {
        this._removeRefreshLockInterval();
        console.debug('_addRefreshLockInterval REFRESH_LOCK_TIME', REFRESH_LOCK_TIME);
        refreshLockInterval = window.setInterval(function() {
            WebSocketActions.refreshActivityLock(
                'act-lock-refresh',
                { actWebSocket: actWebSocket }
            );
        }, REFRESH_LOCK_TIME);
    },

    _removeRefreshLockInterval: function() {
        console.debug('_removeRefreshLockInterval', refreshLockInterval);
        if (refreshLockInterval >= 0) {
            console.debug('_removeRefreshLockInterval clearInterval');
            window.clearInterval(refreshLockInterval);
            refreshLockInterval = -1;
        }
    },

    onRefreshActivityLockCompleted: function(actionID, actWS) {
        // console.log("in onRefreshActivityLockCompleted!");
        //need actWebSocket = actWS ?
        this.emitStatus();
    },

    onRefreshActivityLockFailed: function(actionID, err) {
        console.error("in onRefreshActivityLockFailed!", err);
    },

    onUpdateActivityVersionCompleted: function(actionID, version) {
        // console.log("in onUpdateActivityVersionCompleted!", actionID, version);
        if (actWebSocket) {
            actWebSocket.activityVersion = version;
        }
        else {
            console.warn("actWebSocket not found in WebSocketStore");
        }

        this.emitStatus();
    },

    onUpdateActivityVersionFailed: function(actionID, err) {
        console.error("in onUpdateActivityVersionFailed!", err);
        this.emitStatus();
    },

    //resetStoreCompleted is called when EditActivity does not currently have activity lock
    onResetStoreCompleted: function(actionId, lockProcessBegun) {
        console.debug("in onResetStoreCompleted!", actionId);
        this._removeRefreshLockInterval();
        action = { id: actionId };
        if (actWebSocket && actWebSocket.isConnecting) { //if activity lock WS is pending flag to disconnect when connection is completed
            console.log('actWebSocket && actWebSocket.isConnecting - flagToDisconnect set to true');
            flagToDisconnect = true;
        }
        else if (!actWebSocket && lockProcessBegun) {
            console.log('!actWebSocket && lockProcessBegun - flagToDisconnect set to true');
            flagToDisconnect = true; // if actWebSocket does not yet exist and the component has begun the locking action, we're still waiting on onGetActivityLockCompleted/Failed
        }
        else {
            //console.log('else - flagToDisconnect set to false')
            flagToDisconnect = false;
        }

        this._resetStoredWebsocket();
        this.emitStatus();
    },

    onDevTestWSDisconnectCompleted: function() {
        console.debug("DEV: disconnecting websocket...");
        actWebSocket.sock.disconnect();
    }
});

module.exports = WebSocketStore;
